var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      staticStyle: { overflow: "hidden", "z-index": "2000" },
      attrs: { "data-backdrop": "static" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg modal-dialog-scrollable",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _c("i", { staticClass: "fa fa-gear" }),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.$t("kanbanAttributes")))])
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.dismiss.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "div",
                { staticClass: "btn-group" },
                [
                  _vm.canActivity
                    ? _c(
                        "TabButton",
                        {
                          attrs: { tab: "system" },
                          model: {
                            value: _vm.tab,
                            callback: function($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("kanbanAttributesSystem")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "TabButton",
                    {
                      attrs: { tab: "custom" },
                      model: {
                        value: _vm.tab,
                        callback: function($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab"
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("kanbanAttributesCustom")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm.canActivity
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tab === "system",
                          expression: "tab === 'system'"
                        }
                      ]
                    },
                    [
                      _c("CellAttributeEditor", {
                        staticClass: "form-group",
                        attrs: {
                          state: _vm.state,
                          board: _vm.board,
                          attributes: _vm.systemAttributes
                        }
                      }),
                      _vm._v(" "),
                      _c("ActivityAttributeEditor", {
                        staticClass: "form-group",
                        attrs: {
                          state: _vm.state,
                          board: _vm.board,
                          attributes: _vm.systemAttributes
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tab === "custom",
                      expression: "tab === 'custom'"
                    }
                  ]
                },
                [
                  _vm._l(_vm.definitions, function(def) {
                    return _c("AttributeEditor", {
                      key: def.id,
                      attrs: {
                        definition: def,
                        attribute: _vm.getAttribute(def)
                      }
                    })
                  }),
                  _vm._v(" "),
                  !_vm.definitions.length
                    ? _c("div", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("kanbanNoAttributesDefined")) +
                            "\n          "
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { disabled: _vm.saving },
                  on: { click: _vm.save }
                },
                [
                  _vm.saving
                    ? _c("Spinner", { attrs: { small: true } })
                    : _vm._e(),
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("btnSave")) + "\n        "
                  )
                ],
                1
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }